module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Novo Relatório Técnico de Extensão'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alertaEdicao",
    attrs: {
      "dense": "",
      "type": "info",
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n                Em caso de dúvidas ou sugestões entrar em contato pelo e-mail "), _c('a', {
    attrs: {
      "href": "mailto:suporte.proex@ufes.br"
    }
  }, [_vm._v("suporte.proex@ufes.br")]), _vm._v(". Já em caso de problemas com o sistema\n                entrar em contato pelo "), _c('a', {
    attrs: {
      "href": "https://redmine.ufes.br/projects/suporte-projetos-extensao/issues/new",
      "target": "_blank"
    }
  }, [_vm._v("Sistema de Suporte")]), _vm._v(".\n              ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.projeto.titulo !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Título",
      "value": this.projeto.titulo
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Título",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.projeto.nomeCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Nome do coordenador",
      "value": this.projeto.nomeCoordenador
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Nome do coordenador",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.projeto.idProjeto !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Número",
      "value": "-"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.projeto.classificacaoSecundaria.descricao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Tipo",
      "value": this.projeto.classificacaoSecundaria.descricao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Tipo",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [(_vm.projeto.classificacaoSecundaria.id === 39729 || _vm.projeto.classificacaoSecundaria.id === 44194 || _vm.projeto.classificacaoSecundaria.id === 44195 || _vm.projeto.classificacaoSecundaria.id === 39730) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label, item",
    attrs: {
      "id": "v-radio-group_label",
      "mandatory": true,
      "label": "Tipo do relatório"
    },
    model: {
      value: (_vm.relatorioExtensao.tipoRelatorioTecnicoItem),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "tipoRelatorioTecnicoItem", $$v)
      },
      expression: "relatorioExtensao.tipoRelatorioTecnicoItem"
    }
  }, [_c('v-radio', {
    staticClass: "opcaoRadio",
    attrs: {
      "value": 3,
      "label": "Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.relatorioHabilitadoAcaoRegistroTardio() === false) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label, item",
    attrs: {
      "id": "v-radio-group_label",
      "mandatory": true,
      "label": "Houve mudança nas datas de início e/ou de conclusão da ação de extensão?"
    },
    model: {
      value: (_vm.relatorioExtensao.mudancaDatasAcao),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "mudancaDatasAcao", $$v)
      },
      expression: "relatorioExtensao.mudancaDatasAcao"
    }
  }, [_c('v-radio', {
    staticClass: "opcaoRadio",
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "opcaoRadio",
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.mudancaDatasAcao === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _vm._v(" "), _c('label', {
    staticClass: "textoConfirmaMudancaDatas"
  }, [_vm._v("Confirme as datas de início e de conclusão da ação de\n                      extensão")])])], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.mudancaDatasAcao === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data de início",
      "type": "date",
      "required": "",
      "prepend-icon": "event"
    },
    model: {
      value: (_vm.relatorioExtensao.dataInicio),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "dataInicio", $$v)
      },
      expression: "relatorioExtensao.dataInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data de conclusão",
      "type": "date",
      "required": "",
      "prepend-icon": "event"
    },
    model: {
      value: (_vm.relatorioExtensao.dataConclusao),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "dataConclusao", $$v)
      },
      expression: "relatorioExtensao.dataConclusao"
    }
  })], 1), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.mudancaDatasAcao === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _vm._v(" "), _c('label', {
    staticClass: "item"
  }, [_vm._v("Justifique a mudança")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "1",
      "auto-grow": "",
      "counter": "500",
      "rules": _vm.obrigatorio.concat( _vm.rules500)
    },
    model: {
      value: (_vm.relatorioExtensao.justificativaMudancaDatasAcao),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "justificativaMudancaDatasAcao", $$v)
      },
      expression: "relatorioExtensao.justificativaMudancaDatasAcao"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39733 || _vm.projeto.classificacaoSecundaria.id === 39734 || _vm.projeto.classificacaoSecundaria.id === 39731) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label, item",
    attrs: {
      "id": "v-radio-group_label",
      "mandatory": true,
      "label": "Tipo do relatório"
    },
    model: {
      value: (_vm.relatorioExtensao.tipoRelatorioTecnicoItem),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "tipoRelatorioTecnicoItem", $$v)
      },
      expression: "relatorioExtensao.tipoRelatorioTecnicoItem"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": 2,
      "label": "Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 2) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("*Em caso de \"Relatório Parcial com Renovação\", é necessária a atualização das atividades e\n                      outras informações relativas ao novo interstício de execução da ação.")])])], 1), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _vm._v(" "), _c('label', {
    staticClass: "textoInformaPeriodoRelatorio"
  }, [_vm._v("Informe o período a que se refere o relatório")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "type": "date",
      "required": "",
      "prepend-icon": "event"
    },
    model: {
      value: (_vm.relatorioExtensao.dataInicial),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "dataInicial", $$v)
      },
      expression: "relatorioExtensao.dataInicial"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "type": "date",
      "required": "",
      "prepend-icon": "event"
    },
    model: {
      value: (_vm.relatorioExtensao.dataFinal),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "dataFinal", $$v)
      },
      expression: "relatorioExtensao.dataFinal"
    }
  })], 1), _vm._v(" "), _c('v-spacer')], 1)], 1) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.novoRelatorioTecnicoExtensao
    }
  }, [_vm._v("Adicionar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56b87bbe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/relatorio/novo-relatorio-tecnico.vue
// module id = 755
// module chunks = 0